import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
 
    BlobServiceClient,
  BlobUploadCommonResponse,
} from '@azure/storage-blob';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AIImageUploadService {
  private containerName = 'droneimages';
  private blobServiceClient!: BlobServiceClient;

  constructor(private http: HttpClient) {}

  uploadFile(
    file: File,
    sasToken: string,
    foldername:string,
    url:string,
    progressCallback: (progress: number) => void
  ): Observable<void> {
    this.blobServiceClient = new BlobServiceClient(
      `${url}?${sasToken}`
    );
    return this.performUpload(file,foldername, progressCallback);
  }

  private performUpload(
    file: File,
    folderName:string,
    progressCallback: (progress: number) => void
  ): Observable<void> {
    return new Observable((observer) => {
      const containerClient = this.blobServiceClient.getContainerClient(
        this.containerName
      );
      const blobClient = containerClient.getBlockBlobClient(
        folderName+'/'+file.name
      );
      blobClient
        .uploadData(file, {
          blobHTTPHeaders: { blobContentType: file.type },
          onProgress: (progress) => {
            const percent = progress.loadedBytes / file.size;
            progressCallback(percent);
          },
        })
        .then((response: BlobUploadCommonResponse) => {
          if (
            response._response.status >= 200 &&
            response._response.status < 300
          ) {
            observer.next();
            observer.complete();
          } else {
            observer.error(
              new Error(
                'Upload failed with status: ' + response._response.status
              )
            );
          }
        })
        .catch((err) => observer.error(err));
    });
  }
}
